class PayPalPaymentHelper {
    constructor() {
        this.enabled = false;
        this.env = ''; //sandbox Or 'production'
        this.clientId = '';
        this.locale = 'en_GB';
        this.commit = true;
        this.color = 'silver';
        this.size = 'responsive';
        this.label = 'pay';//'paypal',
        this.tagline = false;
        this.shape = 'rect';
        this.placeholderId = 'paypal-button';
        this.paymentIsLocked = false;
        this.createPaymentUrl = null;
        this.executePaymentUrl = null;
    }
    onPayPalPaymentLoaded() {
        if (!this.enabled) return;

        if (window.paypal && paypal.Button) {
            let helperInstance = this;
            paypal.Button.render({
                env: this.env,
                //this client section may not be needed - https://developer.paypal.com/demo/checkout-v4/#/pattern/server
                //client: {
                //    sandbox: this.env === 'sandbox' ? this.clientId : '',
                //    production: this.env === 'production' ? this.clientId : ''
                //},
                locale: this.locale,
                commit: this.commit,
                style: {
                    color: this.color,
                    size: this.size,
                    label: this.label,
                    tagline: this.tagline,
                    shape: this.shape
                },
                payment: function (resolve, reject) {  //onclick
                    helperInstance.paymentIsLocked = false;
                    const productData = helperInstance.onProductDataRequested();
                    if (!productData) {
                        helperInstance.onError("Product data missing", "PayPalPaymentHelper/render/payment", false, true);
                        reject(new Error("Product data missing"));
                        return;
                    }
                    helperInstance.paymentIsLocked = true;
                    helperInstance.onPaymentExecuting();

                    $.ajax({
                        data: JSON.stringify({
                            productId: productData.productId,
                            offerId: productData.offerId,
                            transactionAmount: productData.amountToPay
                        }),
                        type: "POST",
                        contentType: "application/json; charset=utf-8",
                        url: helperInstance.createPaymentUrl,
                        dataType: "json",
                        timeout: 60000,
                        success: function (response, textStatus, jqXHR) {
                            if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                                fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                            }
                            var responseData = response;
                            if (response && response.d) responseData = response.d;

                            if (responseData && responseData.PaymentId) {
                                resolve(responseData.PaymentId);
                            }
                            else {
                                helperInstance.paymentIsLocked = false;
                                helperInstance.onError("PaymentId could not be obtained", helperInstance.createPaymentUrl, true);
                                reject(new Error("PaymentId could not be obtained"));;
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            helperInstance.paymentIsLocked = false;
                            helperInstance.onError(errorThrown, helperInstance.createPaymentUrl, true);
                            reject(errorThrown);

                            if (typeof (fourdHandleAjaxError) != 'undefined') {
                                fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                            }
                        }
                    });
                },
                onAuthorize: function (data, actions) {
                    $.ajax({
                        data: JSON.stringify({ payerId: data.payerID, paymentId: data.paymentID }),
                        type: "POST",
                        contentType: "application/json; charset=utf-8",
                        url: helperInstance.executePaymentUrl,
                        dataType: "json",
                        timeout: 60000,
                        success: function (response, textStatus, jqXHR) {
                            if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                                fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                            }
                            try {
                                var isAccepted = false;
                                var responseData = response;
                                if (response && response.d) responseData = response.d;

                                if (responseData) {
                                    if (typeof (responseData.TransactionAccepted) != 'undefined') {
                                        isAccepted = responseData.TransactionAccepted;
                                    } else if (typeof (responseData.Success) != 'undefined') { // Old field to be removed
                                        isAccepted = responseData.Success;
                                    }
                                }

                                if (!isAccepted) {
                                    helperInstance.onError(helperInstance.executePaymentUrl + " outcome was non success", helperInstance.executePaymentUrl, true);
                                }

                                helperInstance.onPaymentExecuted(isAccepted, responseData);
                            }
                            catch (err) {
                                helperInstance.onError(err, 'PayPalPaymentHelper/onAuthorize', true);
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            helperInstance.onError(errorThrown, helperInstance.executePaymentUrl, true);

                            if (typeof (fourdHandleAjaxError) != 'undefined') {
                                fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                            }
                        }
                    });
                    helperInstance.paymentIsLocked = false;
                },
                onCancel: function (data, actions) {
                    helperInstance.onPaymentCancelled({
                        data: data,
                        actions: actions
                    });
                    helperInstance.paymentIsLocked = false;
                },
                onError: function (err) {
                    helperInstance.onError(err, "PayPalPaymentHelper/render/onError", helperInstance.paymentIsLocked);
                    helperInstance.paymentIsLocked = false;
                }
            },
                '#' + this.placeholderId);

            this.onIsReadyToPayResult(true);// Can we detect readiness better?
        }
    }
    initialise(options) {
        var result = false;

        //paypal.Button must be loaded
        if (!window.paypal || !paypal.Button) return result;

        if (!options) options = {};
        if (!options.config) options.config = {};
        if (!options.callbacks) options.callbacks = {};
        if (options.config.env === 'live') options.config.env = 'production'; //incase direct AppMode value is used
        if (typeof (FourDConfiguration) !== 'undefined' && FourDConfiguration.endpoints) {
            if (!options.config.createPaymentUrl && typeof (FourDConfiguration.endpoints.paypalCreatePayment) == 'string') options.config.createPaymentUrl = FourDConfiguration.endpoints.paypalCreatePayment;
            if (!options.config.executePaymentUrl && typeof (FourDConfiguration.endpoints.paypalExecutePayment) == 'string') options.config.executePaymentUrl = FourDConfiguration.endpoints.paypalExecutePayment;
        }

        if (options.config.env && options.config.createPaymentUrl && options.config.executePaymentUrl) {
            this.env = options.config.env;
            this.createPaymentUrl = options.config.createPaymentUrl;
            this.executePaymentUrl = options.config.executePaymentUrl;
            if (options.config.clientId) this.clientId = options.config.clientId;
            if (options.config.locale) this.locale = options.config.locale;
            if (options.config.commit === true || options.config.commit === false) this.commit = options.config.commit;
            if (options.config.color) this.color = options.config.color;
            if (options.config.size) this.size = options.config.size;
            if (options.config.label) this.label = options.config.label;
            if (options.config.tagline === true || options.config.tagline === false) this.tagline = options.config.tagline;
            if (options.config.shape) this.shape = options.config.shape;
            if (options.config.placeholderId) this.placeholderId = options.config.placeholderId;


            if (options.callbacks.onProductDataRequested) {
                if (typeof (options.callbacks.onProductDataRequested) == 'function') this.onProductDataRequested = options.callbacks.onProductDataRequested;
                if (typeof (options.callbacks.onIsReadyToPayResult) == 'function') this.onIsReadyToPayResult = options.callbacks.onIsReadyToPayResult;
                if (typeof (options.callbacks.onError) == 'function') this.onError = options.callbacks.onError;
                if (typeof (options.callbacks.onPaymentExecuting) == 'function') this.onPaymentExecuting = options.callbacks.onPaymentExecuting;
                if (typeof (options.callbacks.onPaymentCancelled) == 'function') this.onPaymentCancelled = options.callbacks.onPaymentCancelled;
                if (typeof (options.callbacks.onPaymentExecuted) == 'function') this.onPaymentExecuted = options.callbacks.onPaymentExecuted;

                result = true;
                this.enabled = true;

                this.onPayPalPaymentLoaded();
            }
        }
        return result;
    }
    onProductDataRequested() { return null; }
    onIsReadyToPayResult(isAccepted) { }
    onError(err, stageText, wasPaymentExecuting, wasProductMissing) { }
    onPaymentExecuting() { }
    onPaymentCancelled(event) { }
    onPaymentExecuted(isAccepted, responseData) { }
};

const PayPalPayment = new PayPalPaymentHelper();